import type { Wrex } from '../../types';

/**
 * Check whether a node is an element with type.
 */
export const isElement = (node: any): node is Wrex.Element => node && 'children' in node && !!(node as any).type;
